import { useEffect } from "react";
import { useReveal } from "@/hooks/useReveal";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import TrustStrip from "@/components/site/TrustStrip";
import Services from "@/components/site/Services";
import NordItalia from "@/components/site/NordItalia";
import Insurance from "@/components/site/Insurance";
import Team from "@/components/site/Team";
import Manifesto from "@/components/site/Manifesto";
import Stats from "@/components/site/Stats";
import Process from "@/components/site/Process";
import Zone from "@/components/site/Zone";
import Testimonials from "@/components/site/Testimonials";
import Faq from "@/components/site/Faq";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import StickyMobileCTA from "@/components/site/StickyMobileCTA";
import FloatingCTA from "@/components/site/FloatingCTA";

export default function Landing() {
  useReveal();

  useEffect(() => {
    document.title = "Sicilia Traslochi · Caltanissetta → Nord Italia · Preventivo Gratuito";
  }, []);

  return (
    <div className="min-h-screen bg-white text-brand-ink antialiased pb-20 lg:pb-0" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <TrustStrip />
        <Services />
        <NordItalia />
        <Insurance />
        <Team />
        <Manifesto />
        <Stats />
        <Process />
        <Zone />
        <Testimonials />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <StickyMobileCTA />
      <FloatingCTA />
    </div>
  );
}
